import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c39e76a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns is-gapless is-multiline" }
const _hoisted_2 = { class: "column is-one-fifth" }
const _hoisted_3 = { class: "column is-four-fifths" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_5 = { class: "modal-card" }
const _hoisted_6 = { class: "modal-card-head" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "modal-card-title" }
const _hoisted_9 = { class: "modal-card-body" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Name", -1))
const _hoisted_12 = { class: "control" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"field\" data-v-1c39e76a><label class=\"label\" data-v-1c39e76a>Tipo</label><div class=\"select\" data-v-1c39e76a><select class=\"select\" data-v-1c39e76a><option selected value=\"\" data-v-1c39e76a>Escolha...</option><option value=\"smart-city\" data-v-1c39e76a>Smart City</option><option value=\"cd\" data-v-1c39e76a>Centro de Distribuição</option><option value=\"loja\" data-v-1c39e76a>Loja</option></select></div></div>", 1)
const _hoisted_14 = {
  key: 0,
  class: "field"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Definir Gateways", -1))
const _hoisted_16 = { class: "control checkbox-grid" }
const _hoisted_17 = { class: "field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Descrição", -1))
const _hoisted_19 = { class: "control" }
const _hoisted_20 = { class: "modal-card-foot" }
const _hoisted_21 = { class: "button-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button save-button",
  type: "submit"
}, "Salvar", -1))
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Nome", -1))
const _hoisted_25 = { class: "control" }
const _hoisted_26 = { class: "field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Tipo", -1))
const _hoisted_28 = { class: "select" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Escolha...", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "temperatura" }, "Temperatura", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "umidade" }, "Umidade", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "nivel" }, "Nível", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "contato" }, "Contato", -1))
const _hoisted_34 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Sensor", -1))
const _hoisted_37 = { class: "control" }
const _hoisted_38 = { class: "link-sensor-value" }
const _hoisted_39 = { class: "normalization-title" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Normalização", -1))
const _hoisted_41 = {
  key: 0,
  class: "normalization-body"
}
const _hoisted_42 = { class: "normalization-data" }
const _hoisted_43 = { class: "norm-input norm-min" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "norm-label" }, "Mín.", -1))
const _hoisted_45 = { class: "norm-field" }
const _hoisted_46 = { class: "norm-input norm-max" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "norm-label" }, "Máx.", -1))
const _hoisted_48 = { class: "norm-field" }
const _hoisted_49 = { class: "normalization-data" }
const _hoisted_50 = { class: "norm-input norm-min" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "norm-label" }, "Mín.", -1))
const _hoisted_52 = { class: "norm-field" }
const _hoisted_53 = { class: "norm-input norm-max" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "norm-label" }, "Máx.", -1))
const _hoisted_55 = { class: "norm-field" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "map-data-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Definir Textos")
], -1))
const _hoisted_57 = { class: "map-data-body" }
const _hoisted_58 = { class: "map-data-data" }
const _hoisted_59 = {
  key: 0,
  class: "control"
}
const _hoisted_60 = { class: "map-data-data" }
const _hoisted_61 = {
  key: 0,
  class: "control"
}
const _hoisted_62 = { class: "button-group" }
const _hoisted_63 = { class: "group-line" }
const _hoisted_64 = { class: "detail-line" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-label" }, "Nome", -1))
const _hoisted_66 = { class: "detail-value" }
const _hoisted_67 = { class: "detail-line" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-label" }, "Tipo", -1))
const _hoisted_69 = { class: "detail-value" }
const _hoisted_70 = { class: "detail-line" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-label" }, "Descrição", -1))
const _hoisted_72 = { class: "detail-value" }
const _hoisted_73 = { class: "group-line-data" }
const _hoisted_74 = { class: "detail-line" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-label" }, "Criado em", -1))
const _hoisted_76 = { class: "detail-value" }
const _hoisted_77 = { class: "detail-line" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-label" }, "Modificado em", -1))
const _hoisted_79 = { class: "detail-value" }
const _hoisted_80 = { class: "detail-line" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-label" }, "Criado Por", -1))
const _hoisted_82 = { class: "detail-value" }
const _hoisted_83 = { class: "map-line" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-label" }, "Planta Baixa/Mapa", -1))
const _hoisted_85 = { class: "detail-value" }
const _hoisted_86 = { class: "send-file" }
const _hoisted_87 = { class: "button-ok" }
const _hoisted_88 = {
  ref: "sensormenu",
  class: "sensor-menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftMenu = _resolveComponent("LeftMenu")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_SensorIcon = _resolveComponent("SensorIcon")!
  const _component_SensorSelectCard = _resolveComponent("SensorSelectCard")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalCreateUser = _resolveComponent("ModalCreateUser")!
  const _component_ModalTrigger = _resolveComponent("ModalTrigger")!
  const _component_ModalSetStructure = _resolveComponent("ModalSetStructure")!
  const _component_ModalSetGateways = _resolveComponent("ModalSetGateways")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_LeftMenu, {
          onNewStructure: _ctx.showModal,
          onNewSensor: _ctx.showNewSensorModal,
          onNewUser: _ctx.showModalUser,
          onNewTrigger: _ctx.showNewTriggerModal
        }, null, 8, ["onNewStructure", "onNewSensor", "onNewUser", "onNewTrigger"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TopBar),
        _createVNode(_component_router_view, {
          onSelectedStructure: _ctx.selectStructure,
          onNewStructure: _ctx.showModal,
          onEditSensor: _ctx.editSensor,
          onEditStructure: _ctx.editStructure,
          onShowStructureDetails: _ctx.showDetailModal,
          onOnEditTriggerClick: _ctx.editTrigger,
          onAssignStrucutre: _ctx.showAssignToStructure,
          onDefineGateways: _ctx.showDefineGatewayModal
        }, null, 8, ["onSelectedStructure", "onNewStructure", "onEditSensor", "onEditStructure", "onShowStructureDetails", "onOnEditTriggerClick", "onAssignStrucutre", "onDefineGateways"]),
        _createElementVNode("div", {
          class: _normalizeClass(["modal", { 'is-active': _ctx.addStructure }])
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("header", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                (_ctx.form.id)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "fa-regular fa-folder"
                    }))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      icon: "fa-solid fa-folder-plus"
                    }))
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.form.id ? 'Editar Estrutura' : 'Adicionar Estrutura'), 1),
              _createElementVNode("button", {
                class: "delete",
                "aria-label": "close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              })
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.saveStructure(_ctx.form)), ["prevent"]))
            }, [
              _createElementVNode("section", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "input",
                      placeholder: "Nome",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.form.name]
                    ])
                  ])
                ]),
                _hoisted_13,
                (_ctx.selectedStructure == 'root')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gateways, (gateway) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: gateway.id,
                            class: "checkbox-item"
                          }, [
                            _createVNode(_component_CheckBox, {
                              checked: _ctx.selectedGateways.includes(gateway.id),
                              onClick: ($event: any) => (_ctx.selectGateway(gateway.id))
                            }, null, 8, ["checked", "onClick"]),
                            _createTextVNode(" " + _toDisplayString(gateway.mac), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_FileUpload, {
                  onOnFileSelect: _ctx.selectFile,
                  selectedFile: _ctx.loadedFile?.name
                }, null, 8, ["onOnFileSelect", "selectedFile"]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("textarea", {
                      id: "",
                      cols: "30",
                      rows: "5",
                      class: "textarea",
                      placeholder: "Descrição",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.form.description]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("footer", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "button",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, "Cancelar"),
                  _hoisted_22
                ])
              ])
            ], 32)
          ])
        ], 2),
        _createVNode(_component_Modal, {
          size: "medium",
          title: "Cadastro de Sensor",
          isActive: _ctx.newSensor,
          onCloseModalClick: _ctx.closeNewSensorModal
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_SensorIcon)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input",
                  placeholder: "Nome",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formSensor.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formSensor.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formSensor.sensorType) = $event))
                }, _hoisted_34, 512), [
                  [_vModelSelect, _ctx.formSensor.sensorType]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", {
                  ref: "linkSensor",
                  class: "link-sensor",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openSensorMenu && _ctx.openSensorMenu(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-link" }),
                  _createElementVNode("div", _hoisted_38, [
                    (_ctx.selectedSensor)
                      ? (_openBlock(), _createBlock(_component_SensorSelectCard, {
                          key: 0,
                          sensor: _ctx.selectedSensor
                        }, null, 8, ["sensor"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-ellipsis" })
                ], 512)
              ])
            ]),
            _createElementVNode("div", {
              ref: "normalizationArea",
              class: "normalization",
              style: _normalizeStyle({ display: _ctx.formSensor.sensorType == 'contato' ? 'none' : 'block' })
            }, [
              _createElementVNode("div", _hoisted_39, [
                (_ctx.formSensor.normalization)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      onClick: _ctx.toggleNormalization,
                      class: "option-normalization",
                      icon: "fa-regular fa-square-minus"
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      onClick: _ctx.toggleNormalization,
                      class: "option-normalization",
                      icon: "fa-regular fa-square-plus"
                    }, null, 8, ["onClick"])),
                _hoisted_40
              ]),
              (_ctx.formSensor.normalization)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createTextVNode(" Entrada "),
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "input",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formSensor.normalization.inputMin) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formSensor.normalization.inputMin]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("div", _hoisted_48, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "input",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formSensor.normalization.inputMax) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formSensor.normalization.inputMax]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createTextVNode(" Saída "),
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "input",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formSensor.normalization.outputMin) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formSensor.normalization.outputMin]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "input",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formSensor.normalization.outputMax) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formSensor.normalization.outputMax]
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 4),
            _createElementVNode("div", {
              ref: "mapArea",
              class: "map-data",
              style: _normalizeStyle({ display: _ctx.formSensor.sensorType == 'contato' ? 'block' : 'none'})
            }, [
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createTextVNode(" true "),
                  (_ctx.formSensor.mapped)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "input",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formSensor.mapped.true) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.formSensor.mapped.true]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createTextVNode(" false "),
                  (_ctx.formSensor.mapped)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "input",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formSensor.mapped.false) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.formSensor.mapped.false]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 4)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeNewSensorModal && _ctx.closeNewSensorModal(...args)))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "button save-button",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveSensor(_ctx.formSensor)))
              }, "Salvar")
            ])
          ]),
          _: 1
        }, 8, ["isActive", "onCloseModalClick"]),
        (_ctx.structureForDetail)
          ? (_openBlock(), _createBlock(_component_Modal, {
              key: 0,
              title: "Detalhes da Estrutura",
              isActive: _ctx.structureForDetail != null,
              onCloseModalClick: _ctx.closeDetailModal
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-folder" })
              ]),
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.structureForDetail.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.type), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.structureForDetail.description), 1)
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.showLocalDateTime(_ctx.structureForDetail.createdAt)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.showLocalDateTime(_ctx.structureForDetail.modifiedAt)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _hoisted_81,
                  _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.structureForDetail.createdBy), 1)
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_FileUpload, {
                      onOnFileSelect: _ctx.selectFile,
                      selectedFile: _ctx.loadedFile?.name || _ctx.loadedFilename
                    }, null, 8, ["onOnFileSelect", "selectedFile"]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("button", {
                        class: "button",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.upload(_ctx.structureForDetail)))
                      }, [
                        _createElementVNode("span", null, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-cloud-arrow-up" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("button", {
                    class: "button",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeDetailModal && _ctx.closeDetailModal(...args)))
                  }, "Ok")
                ])
              ]),
              _: 1
            }, 8, ["isActive", "onCloseModalClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalCreateUser, {
          isActive: _ctx.newUser,
          onOnClose: _ctx.closeModalUser
        }, null, 8, ["isActive", "onOnClose"]),
        _createVNode(_component_ModalTrigger, {
          trigger: _ctx.selectedTrigger,
          show: _ctx.newTrigger,
          onOnCloseModal: _ctx.closeNewTriggerModal
        }, null, 8, ["trigger", "show", "onOnCloseModal"]),
        _createVNode(_component_ModalSetStructure, {
          structure: _ctx.selectedStructure,
          show: _ctx.showAssignModal,
          onOnCloseClick: _ctx.hideAssignToStructure,
          onOnSaveClick: _ctx.savePermissions
        }, null, 8, ["structure", "show", "onOnCloseClick", "onOnSaveClick"]),
        _createVNode(_component_ModalSetGateways, {
          structure: _ctx.selectedStructure,
          show: _ctx.showGatewayModal,
          onOnCloseClick: _ctx.hideDefineGatewayModal
        }, null, 8, ["structure", "show", "onOnCloseClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_88, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensors, (sensor) => {
        return (_openBlock(), _createBlock(_component_SensorSelectCard, {
          sensor: sensor,
          key: sensor.id,
          onClick: ($event: any) => (_ctx.selectSensor(sensor))
        }, null, 8, ["sensor", "onClick"]))
      }), 128))
    ], 512)
  ], 64))
}